const calculateSst = (roomTemp: number, td: number): number => {
  return roomTemp - td;
};

export default calculateSst;
